var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.977,
    height: 20,
    viewBox: "0 0 19.977 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Transaction",
    "data-name": "My Transaction",
    transform: "translate(-283.958 36.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20860",
    "data-name": "Path 20860",
    d: "M283.959-26.021q0-3.745,0-7.49,0-.674,0-1.348a1.077,1.077,0,0,1,1.149-1.149h12.714c.213,0,.426,0,.638,0a1.06,1.06,0,0,1,1.074,1.069c.007.965,0,1.931,0,2.9a.533.533,0,0,1-.419.548.541.541,0,0,1-.608-.308.708.708,0,0,1-.045-.294c0-.895,0-1.789,0-2.684,0-.126-.032-.159-.16-.159q-6.282.006-12.564,0c-.192,0-.384.005-.576,0-.106,0-.133.032-.133.134,0,1.057,0,2.114,0,3.171q0,4.4,0,8.8,0,2.771,0,5.543c0,.158,0,.158.165.158h5.769a.547.547,0,0,1,.57.441.543.543,0,0,1-.344.6.614.614,0,0,1-.221.033h-5.869a1.073,1.073,0,0,1-1.147-1.138q0-4.413,0-8.826Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20861",
    "data-name": "Path 20861",
    d: "M587.02,274.473a6.22,6.22,0,1,1,6.166,6.233A6.217,6.217,0,0,1,587.02,274.473Zm6.214-5.119a5.138,5.138,0,1,0,5.148,5.126A5.149,5.149,0,0,0,593.234,269.354Z",
    transform: "translate(-295.525 -296.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20862",
    "data-name": "Path 20862",
    d: "M400.611,121.551q-2.214,0-4.429,0a.573.573,0,0,1-.546-.26.531.531,0,0,1,.459-.812c.525-.007,1.051,0,1.576,0h7.281c.071,0,.142,0,.213,0a.534.534,0,0,1,.024,1.063,2.4,2.4,0,0,1-.25.008Z",
    transform: "translate(-108.804 -152.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20863",
    "data-name": "Path 20863",
    d: "M398.139,275.572c.651,0,1.3,0,1.952,0a.516.516,0,0,1,.5.316.51.51,0,0,1-.076.563.52.52,0,0,1-.429.2q-1.933,0-3.867,0a.535.535,0,0,1-.556-.427.542.542,0,0,1,.306-.6.662.662,0,0,1,.281-.047Z",
    transform: "translate(-108.899 -303.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20864",
    "data-name": "Path 20864",
    d: "M397.46,585.771c.408,0,.817,0,1.225,0a.524.524,0,0,1,.511.417.536.536,0,0,1-.273.591.577.577,0,0,1-.277.064c-.8,0-1.592,0-2.388,0a.538.538,0,1,1,0-1.075c.4,0,.8,0,1.2,0Z",
    transform: "translate(-108.944 -606.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20865",
    "data-name": "Path 20865",
    d: "M397.442,431.72c-.4,0-.792,0-1.188,0a.536.536,0,0,1-.567-.551.53.53,0,0,1,.529-.524c.242-.006.483,0,.725,0,.563,0,1.125,0,1.688,0a.538.538,0,1,1,0,1.073c-.4,0-.792,0-1.188,0Z",
    transform: "translate(-108.932 -455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20866",
    "data-name": "Path 20866",
    d: "M735.786,381c.817,0,1.635,0,2.452,0,.117,0,.141.035.145.147a3.427,3.427,0,0,1-.351,1.782,4.841,4.841,0,0,1-1.21,1.451c-.082.068-.089.1,0,.171a4.742,4.742,0,0,1,1.227,1.483,3.194,3.194,0,0,1,.334,1.6c-.011.3,0,.3-.3.3h-4.73c-.167,0-.161,0-.169-.17a3.33,3.33,0,0,1,.479-1.987,5.015,5.015,0,0,1,1.092-1.229c.074-.061.082-.089,0-.155a4.588,4.588,0,0,1-1.361-1.765,3.77,3.77,0,0,1-.213-1.537c0-.1.068-.085.128-.085h2.478Zm-.01,5.854h0c.446,0,.892,0,1.339,0,.092,0,.112-.027.074-.107-.011-.023-.017-.047-.027-.07a3.85,3.85,0,0,0-1.324-1.534c-.054-.04-.089-.016-.133.015a4.443,4.443,0,0,0-.492.406,3.241,3.241,0,0,0-.835,1.172c-.037.1-.021.119.083.118C734.9,386.851,735.338,386.854,735.776,386.854Zm.009-4.779h0c-.417,0-.833,0-1.25,0-.2,0-.221-.044-.122.188a3.768,3.768,0,0,0,1.317,1.521.088.088,0,0,0,.122-.012c.124-.1.252-.192.371-.3a3.353,3.353,0,0,0,.958-1.277c.038-.1.031-.128-.083-.126C736.66,382.079,736.222,382.075,735.785,382.075Z",
    transform: "translate(-438.009 -406.618)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon7);
export default __webpack_public_path__ + "static/media/sidebar_icon7.2f425f7d57a9b871cd47795a034d72de.svg";
export { ForwardRef as ReactComponent };